import { ISettlementAndFeeCategoryDefinitionData } from './ISettlementAndFeeCategoryDefinition';

export const SECTIONDEFINITION_SEQUENCE_PAYOFFS = 11;

export interface ISectionDefinitionData {
  statementSectionDefinitionId: string;

  sectionLetter: string;
  sectionDescription: string;
  sectionSeq: number;
  sectionPropertyTotalNames: string[];
  statementSettlementAndFeeCategoryDefinitions: ISettlementAndFeeCategoryDefinitionData[];
}

export type ISectionDefinitionResponse = ISectionDefinitionData;

export const createSectionDefinitionData = ({
  statementSectionDefinitionId = 'Not Set',
  sectionLetter = 'Not Set',
  sectionDescription = 'Not Set',
  sectionSeq = 0,
  sectionPropertyTotalNames = [],
  statementSettlementAndFeeCategoryDefinitions = [],
}: Partial<ISectionDefinitionData>): ISectionDefinitionData => ({
  statementSectionDefinitionId,
  sectionLetter,
  sectionDescription,
  sectionSeq,
  sectionPropertyTotalNames,
  statementSettlementAndFeeCategoryDefinitions,
});
